<template>
  <custom-dialog width="450px" :appendToBody="true" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" ref="form" label-width="auto" :rules="rules">
        <el-form-item :label="$t('dms_device_newPartSn_dialog.jiu_ling_jianSN')" prop="oldPartSn">
          <el-input v-model="form.oldPartSn"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button size="small" type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
// import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        oldPartSn: ''
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        oldPartSn: {
          required: true,
          message: this.$t('dms_device_newPartSn_dialog.qtxjljgg'),
        }
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        const row = this.model.data;
        this.$setFormatData(this.form, row);
      }
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        this.$message({
          message: this.$t('Common.com_modify_success'),
          type: 'success'
        });
        this.visible = false;
        this.$emit('success', this.form);

      });
    }
  }
};
</script>

<style lang="scss"></style>
